<template>
  <v-app id="systimes">
    <v-container>
      <v-row justify="center">
        <v-col md="6">
          <v-toolbar color="blue" dark>
            <v-app-bar-nav-icon to="/settings"></v-app-bar-nav-icon>
            <v-toolbar-title>
              SysTimes
              <span class="version">V.:&nbsp;{{ version }}</span>
            </v-toolbar-title>
          </v-toolbar>
        </v-col>
      </v-row>

      <v-row class="mt-6" justify="center">
        <v-col md="6">
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import api from "./api.js";

export default {
  data: () => ({
    version: localStorage.getItem("systimes.version"),
  }),
  mounted() {
    this.$router.push("/Token");
    axios
      .post(api.URL() + "/api/v1/token", { token: localStorage.getItem("systimes.token" + api.getEmp()) })
      .then((response) => {
        if (response.data == "OK") {
          this.$store.commit("setAuth", true);
          this.$router.push("/");
        }
        else {
          this.$store.commit("setAuth", false);
        }
      });
  },
  created() {
    console.log("Comprovant actualitzacions...");
    fetch(api.URL() + "/api/v1/version")
      .then((response) => {
        return response.json();
      })
      .then((version) => {
        console.log(version);
        if (localStorage.getItem("systimes.version") != version) {
          console.log("Actualitzo!");
          localStorage.setItem("systimes.version", version);
          // window.location.reload(true);
          setTimeout(
            function () {
              window.location.reload(true);
            },
            2000
          );
        }
      });
  }
};
</script>